enum PasswordError {
    CHARACTERS = '半角英大文字、英小文字をそれぞれ1文字以上含めてください',
    LENGTH = '12文字以上で入力してください',
    NO_NUMBERS = '半角数字を1文字以上含めてください',
    SAME_AS_EMAIL = 'メールアドレスと異なる文字列を入力してください',
}

export const passwordValidate = (username: string, password: string) => {
    const errors = [] as Array<string>
    if (password === username) errors.push(PasswordError.SAME_AS_EMAIL)
    if (!/\d/.test(password)) errors.push(PasswordError.NO_NUMBERS)
    if (password.toUpperCase() === password || password.toLowerCase() === password)
        errors.push(PasswordError.CHARACTERS)
    if (password.length < 12) {
        errors.push(PasswordError.LENGTH)
    }
    return errors
}
